import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 8) return setErr("Password must be at least 8 characters.");
    if (pw !== confirm) return setErr("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/admin/password/confirm", { token, new_password: pw });
      toast.success("Password updated — sign in with your new password.");
      nav("/admin/login");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Could not reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="page-reset-password">
      <SEO title="Set a new password" path="/admin/reset-password" />
      <form onSubmit={submit} className="w-full max-w-sm bg-[#F5F5F7] rounded-3xl p-8 space-y-4">
        <p className="eyebrow">Admin</p>
        <h1 className="text-h3">Set a new password</h1>
        {!token && <p className="text-sm text-[#FF3B30]">This reset link is missing a token. Request a new one.</p>}
        <div>
          <label className="text-sm">New password (min 8 characters)</label>
          <input
            required
            type="password"
            minLength={8}
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            data-testid="reset-password"
            className="mt-2 w-full h-12 px-4 rounded-xl bg-white focus:ring-1 focus:ring-[#0066FF] focus:outline-none"
          />
        </div>
        <div>
          <label className="text-sm">Confirm new password</label>
          <input
            required
            type="password"
            minLength={8}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="reset-password-confirm"
            className="mt-2 w-full h-12 px-4 rounded-xl bg-white focus:ring-1 focus:ring-[#0066FF] focus:outline-none"
          />
        </div>
        {err && <p className="text-sm text-[#FF3B30]" data-testid="reset-error">{err}</p>}
        <button type="submit" disabled={loading || !token} className="btn-primary w-full" data-testid="reset-submit">
          {loading ? "Updating..." : "Update password"}
        </button>
        <div className="text-center">
          <Link to="/admin/login" className="text-sm text-[#0066FF]">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
